<script lang="ts">
    import Particles from "svelte-particles";

    let particlesConfig = {
        particles: {
            number: {
                value: 160,
                density: {
                    enable: true,
                    value_area: 800,
                },
            },
            move: {
                direction: "none",
                out_mode: "out",
                enable: true,
                random: true,
                speed: 1,
            },
            size: {
                value: 2,
            },
            opacity: {
                anim: {
                    enable: true,
                    speed: 1,
                    opacity_min: 0.05,
                },
                random: true,
                value: 1,
            },
            line_linked: {
                enable: false,
            },
        },
        retina_detect: true,
    };
</script>

<Particles id="tsparticles" options={particlesConfig} />
